document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-faq-listing-page]")
        || document.querySelector("[data-faq-detail-page]")) {
        import(/* webpackChunkName: "faq-listing" */ "/Features/Faqs/js/faq-listing-page.js").then(async (module) => {
            const faqListing = new module.default();
            await faqListing.init();
        });
    }
});